import Skeleton from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React from "react";
import { ADMIN_API_BASE } from "./adminApi";

export function AdminGraphRow() {
  const graphs = [
    { title: "Download", source: "downloads" },
    { title: "Purchase", source: "purchases" },
    { title: "Activate", source: "activations" },
    { title: "Update check", source: "updates" },
  ];

  return (
    <Row>
      {graphs.map((graph) => (
        <Col lg={3} md={6} key={graph.source}>
          <h4>{graph.title}</h4>
          <img src={`${ADMIN_API_BASE}/21/${graph.source}.svg`} width="320" height="120" alt={`${graph.title} graph`} />
        </Col>
      ))}
    </Row>
  );
}
